import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Presença',
  nextIntents: 'pretendem ir na próxima data',
  nextDate: 'próxima data',
  ended: 'Encerrado',
  upcomingIntents: 'confirmações de hoje em diante',
  upcomingDates: 'Próximas datas',
} satisfies TranslationTree;
